import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import BackgroundBlocks from '../../img/blocks-background.webp'
import BackgroundBlocksMob from '../../img/blocks-background-mob.webp'

function EbAutOne({ ebautData }) {

    return (
        <>
            {ebautData && (

                <section id="ebaut" className="eut-abot relative mb-[60px] md:mb-[120px] pt-60 md:pt-64 lg:pt-80" >
                    <div className="container max-w-screen-xl mx-auto px-[15px] relative">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h2 className="font-bold uppercase text-3xl text-center text-[#245864] mb-8
                                sm:text-4xl md:mb-14 lg:text-left lg:mb-0 lg:text-[60px]">Про івент</h2>
                        </ScrollAnimation>

                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <div className="flex flex-col md:flex-row-reverse md:gap-5 md:items-start lg:items-end xl:gap-16">
                                <div className="relative w-full mb-8 md:mb-0 md:w-1/2 pt-[56%] md:pt-[28%] overflow-hidden
                                    lg:max-w-[500px]">
                                    <iframe
                                        className="absolute inset-0 w-full h-full"
                                        src="https://www.youtube.com/embed/Rcff3lyCmXA?si=vXp1in9bntqO0LfC"
                                        title="YouTube video player"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                    />
                                </div>
                                <div className="text-lg text-[#235763] md:w-1/2 
                                lg:max-w-[565px] lg:pt-11 xl:pt-24">
                                    <p className="font-semibold mb-8 xl:mb-10">
                                        Ми всі на щось наважуємось. Кожного дня. Почати нову звичку, запустити новий проєкт, зробити крок назустріч собі або у незвідане.
                                    </p>
                                    <p className="mb-8 xl:mb-10">
                                        На <strong>She Congress</strong> говоримо вголос, на що наважилась кожна. В бізнесі чи карʼєрі. Освіті чи комунікаціях. Здорових звичках чи спорті. Благодійності чи волонтерстві. Або не зважилась, і це теж частина шляху.
                                    </p>

                                    <p className="font-bold">На сцені She Congress - кожна історія рішучості важлива.</p>
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>
                    <div  className="absolute top-0 left-0 w-full h-48 md:h-96 lg:h-[485px] z-10">
                        <img src={BackgroundBlocks} alt="" className="absolute hidden md:block object-cover w-full h-full" />
                        <img src={BackgroundBlocksMob} alt="" className="absolute md:hidden object-cover w-full h-full" />
                   </div>
                </section>
            )}
        </>
    );

}

export default EbAutOne